import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { ApiResponse } from 'further-types/api';
import { Api } from 'further-types/firm';
import { api } from 'lib/httpClient';
import { QUERY_STALE_TIME_MS } from 'further-ui/config';

export function useFirm({
  params,
}: {
  params: Api.GetFirmListRequestQuery & {
    disabled?: boolean;
  };
}) {
  const firms = useQuery({
    queryKey: ['firms', { ...params }],
    queryFn: async () => {
      const { data } = await api.get<ApiResponse<Api.GetFirmListResponse>>(
        'firm',
        { params },
      );

      return data.data;
    },
    placeholderData: keepPreviousData,
    staleTime: QUERY_STALE_TIME_MS,
    enabled: !params.disabled,
  });

  return {
    firms,
  };
}
